var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "disabled": _vm.disabled,
      "nudge-top": 8,
      "max-width": _vm.menuWidth
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('div', _vm._b({
          ref: "activator",
          on: {
            "click": _vm.openMenu
          }
        }, 'div', attrs, false), [_c('v-autocomplete', {
          attrs: {
            "items": _vm.value,
            "label": _vm.$t('objects.tag.tags'),
            "disabled": _vm.disabled || _vm.readonly,
            "readonly": "",
            "loading": _vm.loading,
            "item-text": "value",
            "item-value": "id",
            "prepend-icon": _vm.prependIcon,
            "multiple": "",
            "outlined": _vm.outlined,
            "clearable": ""
          },
          on: {
            "click:clear": _vm.clearTags
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_c('tag-chip', {
                attrs: {
                  "value": item,
                  "size": "small"
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.selectedTags,
            callback: function callback($$v) {
              _vm.selectedTags = $$v;
            },
            expression: "selectedTags"
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.isMenu,
      callback: function callback($$v) {
        _vm.isMenu = $$v;
      },
      expression: "isMenu"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_vm.isLoadingTags ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _c('div', [_c('v-subheader', {
    staticClass: "mb-n2"
  }, [_vm._v(" " + _vm._s(_vm.$t("tag.select")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isMenu = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "placeholder": _vm.$t('common.nouns.search'),
      "prepend-inner-icon": 'mdi-magnify',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('v-divider', {
    staticClass: "mt-n4"
  })], 1), _c('div', {
    staticStyle: {
      "max-height": "320px",
      "overflow-y": "auto"
    }
  }, [_vm.selectedTags && _vm.selectedTags.length ? _c('div', [_c('v-subheader', {
    staticClass: "mb-n4 mt-n1"
  }, [_vm._v(" " + _vm._s(_vm.$t("tag.selected")) + " ")]), _vm._l(_vm.selectedTags, function (tag) {
    return _c('div', {
      key: tag.id,
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toggleSelected(tag.id);
        }
      }
    }, [_c('v-list-item', [_c('v-list-item-action', [_c('v-checkbox', {
      attrs: {
        "value": tag.id,
        "readonly": ""
      },
      model: {
        value: _vm.selected,
        callback: function callback($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "d-flex"
    }, [_c('v-sheet', {
      staticClass: "mr-1 ml-1",
      attrs: {
        "width": "18px",
        "height": "18px",
        "rounded": "",
        "color": tag.color
      }
    }), _vm._v(" " + _vm._s(tag.value) + " ")], 1), tag.description ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(tag.description) + " ")]) : _vm._e()], 1)], 1)], 1);
  })], 2) : _vm._e(), _vm.availableUnselectedTags && _vm.availableUnselectedTags.length ? _c('div', [_c('v-divider'), _c('v-subheader', {
    staticClass: "mb-n4 mt-n1"
  }, [_vm._v(_vm._s(_vm.$t("tag.availableTags")))]), _vm._l(_vm.availableUnselectedTags, function (tag) {
    return _c('div', {
      key: 'avail' + tag.id,
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toggleSelected(tag.id);
        }
      }
    }, [_c('v-list-item', [_c('v-list-item-action', [_c('v-checkbox', {
      attrs: {
        "value": tag.id,
        "readonly": ""
      },
      model: {
        value: _vm.selected,
        callback: function callback($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "d-flex"
    }, [_c('v-sheet', {
      staticClass: "mr-1 ml-1",
      attrs: {
        "width": "18px",
        "height": "18px",
        "rounded": "",
        "color": tag.color
      }
    }), _vm._v(" " + _vm._s(tag.value) + " ")], 1), tag.description ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(tag.description) + " ")]) : _vm._e()], 1)], 1)], 1);
  })], 2) : _vm._e()]), _c('v-divider'), true ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "block": ""
    },
    on: {
      "click": function click() {
        return new _vm.TagGoToHelper(_this.$router).goToTagTable({
          partnerId: _vm.partnerId
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("tag.manageTags")) + " ")]) : _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "block": ""
    },
    on: {
      "click": _vm.openCreateDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("tag.createTag")) + " ")], 1)], 1)], 1), _c('create-tag-dialog', {
    attrs: {
      "refs": "createTagDialog",
      "isDialogActive": _vm.isCreateDialogActive,
      "hideButton": true,
      "partnerId": _vm.partnerId
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCreateDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCreateDialogActive = $event;
      },
      "created": _vm.onTagCreated
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }